export default (o, c, d) => {
  c.prototype.isToday = function () {
    const today = window.dayjs.today()
    return this.isSame(today, 'date')
  }
}
